import { useMemo } from 'react';
import { Task } from '../../../types';

export type TaskStatus = 'none' | 'ok' | 'overdue';

interface UseTaskStatusReturn {
    status: TaskStatus;
    hasOverdueTasks: boolean;
    hasActiveTasks: boolean;
    totalTasks: number;
}

export const useTaskStatus = (tasks: Task[]): UseTaskStatusReturn => {
    return useMemo(() => {
        const activeTasks = tasks.filter(task => !task.isCompleted);
        const totalTasks = activeTasks.length;

        if (totalTasks === 0) {
            return {
                status: 'none',
                hasOverdueTasks: false,
                hasActiveTasks: false,
                totalTasks: 0
            };
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const hasOverdueTasks = activeTasks.some(task => {
            if (!task.dueDate) return false;
            const due = new Date(task.dueDate);
            due.setHours(0, 0, 0, 0);
            return due.getTime() < today.getTime();
        });

        return {
            status: hasOverdueTasks ? 'overdue' : 'ok',
            hasOverdueTasks,
            hasActiveTasks: true,
            totalTasks
        };
    }, [tasks]);
};
